import { useState } from 'react'
import { useToastStore } from '@store/useToastStore'
import './Newsletter.scss'

export default function Newsletter() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const addToast = useToastStore((s) => s.addToast)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!email.trim()) return

    setLoading(true)
    try {
      // Stub — will wire to POST /api/subscribers later
      await new Promise((r) => setTimeout(r, 600))
      addToast({ message: 'Te-ai abonat cu succes! 🎉', type: 'success' })
      setEmail('')
    } catch {
      addToast({ message: 'Ceva nu a mers. Încearcă din nou.', type: 'error' })
    } finally {
      setLoading(false)
    }
  }

  return (
    <section className="newsletter" id="contact">
      <div className="section-label">Newsletter</div>
      <h2>
        Fii la curent cu <em>noutățile</em>
      </h2>
      <p>
        Primește rețete de aromoterapie, oferte exclusive și noutăți direct în inbox.
      </p>

      <form className="nl-form" onSubmit={handleSubmit}>
        <input
          className="nl-input"
          type="email"
          placeholder="adresa ta de email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button className="nl-btn" type="submit" disabled={loading}>
          {loading ? 'Se trimite…' : 'Abonează-te'}
        </button>
      </form>
    </section>
  )
}
